import React from "react";
import Body from "components/Body";
import TopLeftSmallShape from "components/Shapes/TopLeftSmallShape";

export default function ParagraphText({ data }) {
  const isHighlighted = data.field_highlighted;
  return (
    <div className="mx-auto lg:max-w-screen-lg h-full">
      {isHighlighted ? (
        <ParagraphTextHighlighted data={data} />
      ) : (
        <>
          {data.field_title && (
            <h2 className="mb-8 font-important text-4xl">{data.field_title}</h2>
          )}
          <div className="prose max-w-none">
            <Body value={data.field_text.processed} />
          </div>
        </>
      )}
    </div>
  );
}

function ParagraphTextHighlighted({ data }) {
  return (
    <div className="relative bg-primary p-8 lg:p-16 rounded-md h-full">
      <div className="absolute top-0 left-0" aria-hidden="true">
        <TopLeftSmallShape className="w-32 h-auto text-white" />
      </div>

      {data.field_title && (
        <h2 className="mb-8 font-important text-2xl text-white">
          {data.field_title}
        </h2>
      )}

      <div className="prose prose-white font-important text-lg max-w-none">
        <Body value={data.field_text.processed} />
      </div>
    </div>
  );
}
